export enum LANGUAGE_CODES {
  EN = "en",
  TR = "tr",
  PL = "pl",
}

export const ROUTES: Record<string, { [lang in LANGUAGE_CODES]: string }> = {
  home: {
    [LANGUAGE_CODES.TR]: "",
    [LANGUAGE_CODES.EN]: "",
    [LANGUAGE_CODES.PL]: "",
  },
  about: {
    [LANGUAGE_CODES.TR]: "about",
    [LANGUAGE_CODES.EN]: "about",
    [LANGUAGE_CODES.PL]: "about",
  },
  services: {
    [LANGUAGE_CODES.TR]: "services",
    [LANGUAGE_CODES.EN]: "services",
    [LANGUAGE_CODES.PL]: "services",
  },
  contact: {
    [LANGUAGE_CODES.TR]: "contact",
    [LANGUAGE_CODES.EN]: "contact",
    [LANGUAGE_CODES.PL]: "contact",
  },
  experience: {
    [LANGUAGE_CODES.TR]: "work-experience",
    [LANGUAGE_CODES.EN]: "work-experience",
    [LANGUAGE_CODES.PL]: "work-experience",
  },
};
